import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import logoImg from "../content/Labo-Lol_logo_noir_02.png";

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

const LogoBackground = () => {
    const logoRef = useRef(null);

    useEffect(() => {
        const logo = logoRef.current;

        if (logo) {
            // Set initial size
            gsap.set(logo, { width: "35vw" });

            // Create scroll animation
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: "html",
                    start: "top top",
                    end: "bottom bottom",
                    scrub: 1,
                    invalidateOnRefresh: true,
                }
            });

            tl.to(logo, {
                width: "90vw",
                ease: "none"
            });

            // Store the timeline for cleanup
            logo._gsapTimeline = tl;
        }

        // Cleanup
        return () => {
            if (logo && logo._gsapTimeline) {
                logo._gsapTimeline.kill();
            }
            ScrollTrigger.getAll().forEach(trigger => {
                if (trigger.trigger === document.documentElement) {
                    trigger.kill();
                }
            });
        };
    }, []);

    return (
        <div className="logo-background">
            <img
                ref={logoRef}
                src={logoImg}
                alt="logo"
            />
        </div>
    )
}

export default LogoBackground